import { GRANT_TYPE, MULTI_FACTOR_CODE, MULTI_FACTOR_TOKEN, OAuthGrantType } from './authentication-service-constants.js';
import { request } from './request.js';
function multiFactorAuthenticationError(message) {
    return new Error(`[Authentication Service]: ${message}`);
}
function createMultiFactorAuthentication(options) {
    const { createHeaders, createTokenFromResponse, getConfiguration, storeToken, verifyResponse, verifyResponseStatus, verifyToken, } = options;
    function activateMultiFactorAuthentication(parameters) {
        const { endpoints } = getConfiguration();
        const headers = createHeaders();
        verifyToken();
        if (!endpoints.multiFactor?.validateActivation) {
            throw multiFactorAuthenticationError('Multi Factor Authentication validateActivation endpoint is not configured.');
        }
        const requestParameters = {
            [MULTI_FACTOR_CODE]: parameters.code,
        };
        return request(endpoints.multiFactor?.validateActivation, requestParameters, headers)
            .then((response) => verifyResponseStatus(response))
            .then((response) => response.json());
    }
    function deactivateMultiFactorAuthentication(parameters) {
        const { endpoints } = getConfiguration();
        const headers = createHeaders();
        verifyToken();
        if (!endpoints.multiFactor?.deactivate) {
            throw multiFactorAuthenticationError('Multi Factor Authentication deactivate endpoint is not configured.');
        }
        const requestParameters = {
            [MULTI_FACTOR_CODE]: parameters.code,
        };
        return request(endpoints.multiFactor.deactivate, requestParameters, headers)
            .then((response) => verifyResponseStatus(response))
            .then((response) => response.json());
    }
    function requestMultiFactorAuthenticationActivation() {
        const { endpoints } = getConfiguration();
        const headers = createHeaders();
        verifyToken();
        if (!endpoints.multiFactor?.activate) {
            throw multiFactorAuthenticationError('Multi Factor Authentication activate endpoint is not configured.');
        }
        return request(endpoints.multiFactor.activate, {}, headers)
            .then((response) => verifyResponse(response))
            .then((response) => response.json());
    }
    function requestNewMultiFactorAuthenticationCode() {
        const { endpoints } = getConfiguration();
        const headers = createHeaders();
        verifyToken();
        if (!endpoints.multiFactor?.resend) {
            throw multiFactorAuthenticationError('Multi Factor Authentication resend endpoint is not configured.');
        }
        return request(endpoints.multiFactor.resend, {}, headers)
            .then((response) => verifyResponseStatus(response))
            .then((response) => response.json());
    }
    function validateMultiFactorAuthentication(parameters) {
        const { endpoints } = getConfiguration();
        const headers = createHeaders();
        if (!endpoints.multiFactor?.validate) {
            throw multiFactorAuthenticationError('Multi Factor Authentication validate endpoint is not configured.');
        }
        const requestParameters = {
            [GRANT_TYPE]: OAuthGrantType.MULTI_FACTOR_AUTHENTICATION,
            [MULTI_FACTOR_CODE]: parameters.code,
            [MULTI_FACTOR_TOKEN]: parameters.token.rawToken(),
        };
        return request(endpoints.multiFactor.validate, requestParameters, headers)
            .then((response) => verifyResponseStatus(response))
            .then((response) => response.json())
            .then(async (response) => {
            if (parameters.storeToken) {
                return storeToken(response).then((token) => ({ response, token }));
            }
            else {
                const token = await createTokenFromResponse(response);
                return Promise.resolve({ response, token });
            }
        });
    }
    return {
        activateMultiFactorAuthentication,
        deactivateMultiFactorAuthentication,
        requestMultiFactorAuthenticationActivation,
        requestNewMultiFactorAuthenticationCode,
        validateMultiFactorAuthentication,
    };
}
export { createMultiFactorAuthentication, };
//# sourceMappingURL=multi-factor-authentication.js.map